import 'styles.css';
import BlueInkEmbed from './embed';

export default BlueInkEmbed;
